import { createApp } from 'vue';
import App from './App.vue';
import './styles/main.scss';
import { FontAwesomeIcon } from './plugins/fontawesome';
import { mountPublicOffers } from './modules/public-offers/index';
import { mountOfferPhone } from './modules/offer-phone/index';

function mountApp() {
  const el = document.getElementById('st-marketplace-app');
  if (!el) return;
  const ds = (el as HTMLElement).dataset || {} as DOMStringMap;
  const props = {
    apiCreate: el.getAttribute('data-api-create') || '',
    apiUpdate: el.getAttribute('data-api-update') || '',
    apiDelete: el.getAttribute('data-api-delete') || '',
    apiList: el.getAttribute('data-api-list') || '',
    apiListArchived: el.getAttribute('data-api-list-archived') || '',
    apiUploadImage: el.getAttribute('data-api-upload-image') || '',
    apiDeleteImage: el.getAttribute('data-api-delete-image') || '',
    apiCategorySearch: (ds.apiCategorySearch as string) || '',
    apiProductSearch: (ds.apiProductSearch as string) || '',
    apiFeaturesSearch: (ds.apiFeaturesSearch as string) || '',
    apiChatInit: (ds.apiChatInit as string) || '',
    apiChatHistory: (ds.apiChatHistory as string) || '',
    apiChatSend: (ds.apiChatSend as string) || '',
    apiChatConversations: (ds.apiChatConversations as string) || '',
    wsChatUrl: (ds.wsChatUrl as string) || '',
    apiAddresses: (ds.apiAddresses as string) || '',
    apiAddressSetDefault: (ds.apiAddressSetDefault as string) || '',
    addAddressUrl: (ds.addAddressUrl as string) || '',
  } as const;
  const app = createApp(App, props);
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.mount(el);
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', mountPublicOffers);
} else {
  mountPublicOffers();
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', mountOfferPhone);
} else {
  mountOfferPhone();
}

if (import.meta.hot) {
  import.meta.hot.accept(() => {
  });
}
